import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar, MatDialog } from '@angular/material';
import { MortgageService } from './mortgage.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Theme } from '../service/AutoTheme';
import { AppComponentClass } from '../service/AppComponent.class';
import { HttpClient } from '@angular/common/http';
import { Mortgage, MortgageForm, Objection, Scripts } from '../../dialer/model/model.mortgage';


import * as $ from 'jquery';
@Component({
  selector: 'app-mortgage',
  templateUrl: './mortgage.component.html',
  styleUrls: ['./mortgage.component.css']
})
export class MortgageComponent extends AppComponentClass<Mortgage, MortgageForm> {
  product_id: any;
  BuildchartData: any = [];
  RunQuote: any;
  healthDatanew: any;
  private __data = new BehaviorSubject<any>(null);
  public solution = this.__data.asObservable();

  private __sdata = new BehaviorSubject<any>(null);
  public sssolution = this.__sdata.asObservable();

  private __odata = new BehaviorSubject<any>(null);
  public objsolution = this.__odata.asObservable();

  private __busshour = new BehaviorSubject<any>(null);
  public busshoursolu = this.__busshour.asObservable();

  private __timezone = new BehaviorSubject<any>(null);
  public timezone = this.__timezone.asObservable();



  form: FormGroup;
  datas = [];
  loadleads: boolean = false;
  step = 0;
  scriptmenu: Scripts[];
  menuright: boolean = true;

  public is_script: boolean = false;
  public currObjection = [];
  displaydata: boolean = false;
  displaydataDiaer: boolean = false;
  PostData1: any

  /* @Input() mortgage : boolean =  false; */

  @Output() objections = new EventEmitter();

  /* @Input() type : string = ""; */
  @Input() set lead(v: Mortgage) {
    console.log("Setting current lead data at morgage");
    console.log(v);
    this.__data.next(v);
  }

  @Input() set sdata(v: Scripts[]) {
    console.log("Setting current scripts");
    console.log(v);
    this.__sdata.next(v);
  }

  @Input() set odata(v: Objection[]) {
    console.log("Setting current obserable");
    console.log(v);
    this.__odata.next(v);
  }

  @Input() set busshour(v: any) {
    this.__busshour.next(v)
  }

  @Input() set dialertimezone(v: any) {
    this.__timezone.next(v)
  }
  @Input() datainInsuranceRES: any;
  public NewVal: any = [];
  public NewValres: any;
  constructor(public data: MortgageService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar, public dialog: MatDialog, public theme: Theme, protected http: HttpClient) {
    super(data, router, fb, msg);
    this.theme.showMenu(false);
  }
  ngOnInit() {
    if (this.datainInsuranceRES) {
      this.NewValres = sessionStorage.setItem("searchData", JSON.stringify(this.datainInsuranceRES));
    }
    this.loadleads = true;
    this.solution.subscribe(res => {
      this.PostData1 = res

      console.log("Changed data on edit " + JSON.stringify(res));
      if (res == null) {
        this.cdata = new MortgageForm(null);
      }
      else {
        this.cdata = new MortgageForm(res);
        sessionStorage.setItem("oldscript", this.cdata.current_script.id.toString());

        this.sssolution.subscribe(rss => {
          console.log("Script Data at Dialer Module TS");
          console.log(rss);
          let tmp = JSON.parse(sessionStorage.getItem('scripts'));
          console.log(tmp);
          if (tmp != undefined || tmp != null) {
            console.log("Script Data at Dialer Module TS LOcal TEmp");
            this.scriptmenu = tmp;
            let count: number = 0;
            tmp.forEach((opt: Scripts) => {
              console.log(opt.id + " == " + this.cdata.current_script.id);
              // count++;   
              if (opt.id == this.cdata.current_script.id) {
                this.cdata.script = opt;
                this.is_script = true;
                console.log("SS Local Data :: " + JSON.stringify(this.cdata.current_script));
                return false;
              }
              else {
                console.log("Current Script ID not matched");
                if (opt.id == parseInt(JSON.parse(sessionStorage.getItem("currscript")))) {
                  this.cdata.script = opt;
                  this.is_script = true;
                  sessionStorage.setItem("oldscript", opt.id.toString());
                  return false;
                }
                /*  else
                 {
                   this.cdata.script=null;
                   this.is_script=true; 
                               
                 } */
              }
              count++;
            });

            if (count == tmp.length) {
              this.cdata.script = tmp[0];
              this.is_script = true;
              sessionStorage.setItem("oldscript", tmp[0].id.toString());
              console.log("Script ARE::::::::::" + JSON.parse(sessionStorage.getItem("currscript")));
              if (JSON.parse(sessionStorage.getItem("currscript")) == 'null' || JSON.parse(sessionStorage.getItem("currscript")) == '0' || JSON.parse(sessionStorage.getItem("currscript")) == "" || JSON.parse(sessionStorage.getItem("currscript")) == null || JSON.parse(sessionStorage.getItem("currscript")) == undefined)
                sessionStorage.setItem('currscript', JSON.stringify(tmp[0].id));
              console.log("Default Script Loaded");
            }
          }
          else {
            console.log("Script Data at Dialer Module TS RESSSS");
            if (rss != null || rss != undefined) {
              this.scriptmenu = rss;
              rss.forEach((opt: Scripts) => {
                if (opt.id == rss[0].id) {
                  this.cdata.script = opt;
                  this.is_script = true;
                  console.log("SS Data :: " + JSON.stringify(this.cdata.current_script));
                }
                else {
                  if (opt.id == parseInt(JSON.parse(sessionStorage.getItem("currscript")))) {
                    this.cdata.script = opt;
                    this.is_script = true;
                  }
                }
              });
            }
            else {
              window.location.reload();
            }
          }
        });
      }
    });

    this.objsolution.subscribe(res => {
      console.log("Objection fields ::");
      if (res != null || res != undefined) {
        this.datas = [];
        let objection = res;
        let currobj = sessionStorage.getItem("objection_id");
        if (currobj != null && currobj != undefined) {
          if (currobj.length > 0) {
            let obj = currobj.split(",");
            // console.log(obj);
            for (let j = 0; j < objection.length; j++) {
              for (let i = 0; i < obj.length; i++) {
                console.log("Current Objection :: " + objection[j].id + "== " + parseInt(obj[i]));
                if (objection[j].id == parseInt(obj[i])) {
                  this.datas[i] = { index: objection[j].id, indexid: [i], value: objection[j].value, abbr: objection[j].abbr, script: objection[j].script, status: objection[j].status, color: "warn" };
                }
              }
              if (!this.datas[j]) {
                this.datas[j] = { index: objection[j].id, indexid: [j], value: objection[j].value, abbr: objection[j].abbr, script: objection[j].script, status: objection[j].status, color: "primary" };
              }
            }
            // console.log(this.datas);
          }
          else {
            for (let j = 0; j < objection.length; j++) {
              this.datas[j] = { index: objection[j].id, indexid: [j], value: objection[j].value, abbr: objection[j].abbr, script: objection[j].script, status: objection[j].status, color: "primary" };
            }
            // console.log(this.datas);
          }
        }
        else {
          for (let j = 0; j < objection.length; j++) {
            this.datas[j] = { index: objection[j].id, indexid: [j], value: objection[j].value, abbr: objection[j].abbr, script: objection[j].script, color: "primary" };
          }
        }
      }
    },
      err => {
        this.msg.open('No Objection are found into the system', 'Clear', {
          duration: 5000,
        });
        // console.log(error);
      });

    this.busshoursolu.subscribe(res => {
      console.log("buss hours")
      console.log(res);

    })

  }
  onclick() {
    let temp = sessionStorage.getItem('searchData');
    this.NewVal = JSON.parse(temp);
    this.NewVal.forEach(element => {
      this.product_id = element.id;
      this.RunQuote = element.run_quote;

    })
    this.displaydata = true;
    this.displaydataDiaer = false;
  }

  dialer() {
    this.displaydataDiaer = true;
    this.displaydata = false;

  }
  ChangeScript(type: number) {
    // console.log("changetype: "+type);
    sessionStorage.setItem("currscript", JSON.stringify(type));
    this.cdata.current_script.id = type;
    let tmp = sessionStorage.getItem('scripts');
    if (tmp == null || tmp == "undefined") {
      this.sssolution.subscribe(rs => {
        if (rs != null || rs != undefined) {
          this.scriptmenu = rs;
          rs.forEach((opt) => {
            if (opt.id == type)
              this.cdata.script = opt;
          });
        }
      });
    }
    else {
      this.scriptmenu = JSON.parse(tmp);
      this.scriptmenu.forEach((opt) => {
        if (opt.id == type) {
          this.cdata.script = opt;
        }
      });
    }
  }

  onObClick(obdata: any) {
    // console.log("Objections click:"+ obdata.index+"  :: Abbr :- "+obdata.abbr+" :::  ObScript : "+obdata.script);
    if (obdata.script != null && obdata.script != undefined)
      this.cdata.script = { id: obdata.index, script_name: obdata.value, script_body: obdata.script };

    this.objections.emit({ id: obdata.index, index: obdata.indexid, abbr: obdata.abbr, color: obdata.color });
    if (obdata.color == "warn")
      this.backScript();
    /* let tmp=JSON.parse(sessionStorage.getItem('objscript'));
    if(tmp !=null || tmp != undefined || tmp !="undefined")
    {
      tmp.forEach((opt)=>{ 
        console.log(opt);           
        if(opt.id_objection==number)
          this.cdata.script=opt;
      });      
    }  */

  }

  backScript() {
    console.log(sessionStorage.getItem("oldscript"));
    this.ChangeScript(parseInt(sessionStorage.getItem("oldscript")));
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  onOpen() {
    $('.right-sidebar').show();
    console.log("data show here");
  }

  closeMenu() {
    this.menuright = true;
    console.log("close");
  }

  ngOnDestory() { }

  Bulidchart() {
    console.log("Product", this.product_id)
    this.data.savebuildchart(this.product_id).subscribe(res => {
      console.log("Data achive", res.message);
      let obj = JSON.parse(res.message)
      this.BuildchartData = obj.result;
      console.log("Data achive", this.BuildchartData);

    })
  }
  OpenDialog(template) {
    let dialogRef = this.dialog.open(template);
  }
  runQuote() {
    window.open(this.RunQuote, '_blank');

  }

  onButtonGroupClick($event){
    let clickedElement = $event.target || $event.srcElement;
    // debugger;
    if( clickedElement.nodeName === "BUTTON" ) {
  
      let isCertainButtonAlreadyActive = clickedElement.parentElement.querySelector(".active");
      // if a Button already has Class: .active
      if( isCertainButtonAlreadyActive ) {
        isCertainButtonAlreadyActive.classList.remove("active");
      }
  
      clickedElement.className += " active";
    }
  
  }
}


